module.exports = __webpack_public_path__ + "07402ae90fd377b6548fe7af79740b76.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/presentation.png
// module id = 620
// module chunks = 0